module.exports = __webpack_public_path__ + "img/chargers.1e739275.webp";